
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/new-grad-jobs/consultation",
      function () {
        return require("private-next-pages/next/new-grad-jobs/consultation.tsx");
      }
    ]);
  